import { useCustomMutation } from "@refinedev/core";
import { useCallback } from "react";

export const useHandleChangeFont = () => {
  const { mutateAsync: addPublicAsset } = useCustomMutation();

  const handleChangeFont = useCallback(
    async (
      purpose: string,
      fontId: string,
      organizationId: string | undefined,
      brandKitId: string | undefined
    ) => {
      if (!organizationId || !brandKitId) return;

      const brandKitAssetUrl = `media/${organizationId}/brand_kits/${brandKitId}/assets`;

      const defaultFontAsset = {
        type: "AddBrandKitAsset",
        asset_id: fontId,
        purpose: purpose,
      };

      try {
        await addPublicAsset({
          url: brandKitAssetUrl,
          method: "put",
          values: defaultFontAsset,
        });
      } catch (error) {
        console.error("Failed to save default font:", error);
      }
    },
    [addPublicAsset]
  );

  return { handleChangeFont };
};
